module.exports = __webpack_public_path__ + "static/media/error-500.22f79544.svg";